import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './ViniedoLogs.css';

function ViniedoLogs({ tableData }) {
    return (
        <div className="viniedo_logs-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No hay logs para este viñedo</h4>
            )}
        </div>
    );
}

export default ViniedoLogs;
